<mat-card appearance="outlined" class="signin-card">
  <mat-card-title>Se connecter</mat-card-title>
  <form (ngSubmit)="connect()" [formGroup]="form">
    @if (!isLoading) {
      <div>
        <p class="space">
          <mat-form-field>
            <mat-label>Email</mat-label>
            <input [(ngModel)]="login.username" formControlName="email" matInput>
            @if (form.get('email').hasError('required')) {
              <mat-error>
                L'email est requis
              </mat-error>
            }
            @if (form.get('email').hasError('email')) {
              <mat-error>
                L'email doit être valide
              </mat-error>
            }
          </mat-form-field>
        </p>
        <p class="space">
          <mat-form-field>
            <mat-label>Mot de passe</mat-label>
            <input [(ngModel)]="login.password" [type]="showPassword ? 'text' : 'password'" class="password_input"
              formControlName="password" matInput>
              <mat-icon (click)="clickShowPassword()" class="password_button">remove_red_eye</mat-icon>
              @if (form.get('password').hasError('required')) {
                <mat-error>
                  Le mot de passe est requis
                </mat-error>
              }
              @if (form.get('password').hasError('minlength')) {
                <mat-error>
                  Le mot de passe doit faire au minimum 8 caractères
                </mat-error>
              }
            </mat-form-field>
            @if (displayMfa) {
              <mat-form-field>
                <mat-label>Code MFA</mat-label>
                <input [(ngModel)]="login.mfa" formControlName="mfa" matInput type="number">
              </mat-form-field>
            }
          </p>
          <p class="space_button">
            <button [disabled]="form.invalid" mat-button>Connexion</button>
          </p>
        </div>
      }
      @if (isLoading) {
        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
      }
    </form>
  </mat-card>
  @if (!isLoading) {
    <mat-card appearance="outlined" class="create-card">
      <mat-card-title>Je n’ai pas d’espace client</mat-card-title>
      <p>
        Créez votre espace client en seulement quelques clics... et simplifiez la gestion de votre compte In Extenso !
      </p>
      <p class="center">
        <button class="signup_button" mat-button [routerLink]="'/register'">Créer mon compte</button>
      </p>
    </mat-card>
  }

